import { useLingui } from "@lingui/react";
import { Archive } from "lucide-react";
import { Button } from "./ui/button";

interface CallArchiveButtonProps {
	isArchived: boolean;
	onClick: () => void;
}

export function CallArchiveButton({
	isArchived,
	onClick,
}: CallArchiveButtonProps) {
	const { i18n } = useLingui();
	const label = isArchived
		? i18n._({ id: "unarchive", message: "Unarchive" })
		: i18n._({ id: "archive", message: "Archive" });

	return (
		<Button
			variant="ghost"
			size="sm"
			onClick={onClick}
			title={label}
			aria-label={label}
			data-testid="call-detail-archive"
		>
			<Archive
				className={`w-4 h-4 ${isArchived ? "text-accent-ink fill-current" : ""}`}
			/>
		</Button>
	);
}
